import { MessageCircle } from "lucide-react";

export default function WhatsAppButton({ message }) {
  const number = "5521984953716";
  const defaultMsg = message || "Olá! Vim pelo site da Nalin Atacado & Varejo e gostaria de atendimento.";
  const url = `https://wa.me/${number}?text=${encodeURIComponent(defaultMsg)}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      className="fixed bottom-20 md:bottom-6 right-4 sm:right-6 z-40 bg-[#25D366] hover:bg-[#1ea952] text-white p-4 rounded-full shadow-lg shadow-black/20 transition-transform hover:scale-105"
      aria-label="Fale conosco no WhatsApp"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}
